import { module } from 'angular'

export default module('kd.ui', [])



// WEBPACK FOOTER //
// ./src/kendu/ui/module.js